import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-formatting',
  templateUrl: './content-formatting.component.html',
  styleUrls: ['./content-formatting.component.sass']
})
export class ContentFormattingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
